// extracted by mini-css-extract-plugin
export default {"column":"column___E5yKt","columnLeft":"columnLeft___URdz6","columnRight":"columnRight___V2tpA"};